import { Outlet } from "react-router-dom";
import { Footer } from "./footer/footer";

export const FooterOnlyLayout = () => (
  <>
    <Outlet />
    <Footer />
  </>
);

export default FooterOnlyLayout;
